var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.AtopicDermatitisNodeComponent)?_c('keep-alive',[_c(_vm.AtopicDermatitisNodeComponent,_vm._b({tag:"component",attrs:{"content":_vm.content,"disabled":_vm.disabled}},'component',_vm.nodeData,false))],1):_c('div',[_vm._v("atopic dermatitis form node not found")])
}
var staticRenderFns = []

export { render, staticRenderFns }